export default {
  /**
   * Api 根目录
   */
  ApiRoot: process.env.VUE_APP_API_ROOT,
  // ApiYJ: 'http://192.168.34.71:8057/service',
  // ApiYSQ: 'http://172.21.144.114:8057/service',
  ApiYJ: 'https://shzhfy.yj.gov.cn/service',
  ApiYSQ: 'https://shzhfy.yj.gov.cn/service', // 水雨情
  ApiRootVideo: 'http://vm.zjdyit.com',
  ApiWeather: 'http://ptszfx.zjdyit.com/service', // 天气
  /**
   * 资源服务根目录（图片，视频等)
   */
  ResRoot: process.env.VUE_APP_API_ROOT,

  /**
   * 文件上传的接口路径
   */
  UploadUrl: `${process.env.VUE_APP_API_ROOT}/file`
}
